import "./scene-3.css";

const element = document.querySelector(".scene-3-img-container");

var nAgt = navigator.userAgent;

if (nAgt.indexOf("Firefox") !== -1) {
  element.classList.add("firefox-display");
}
